import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Box,
  useMediaQuery,
  useTheme,
  Menu,
  MenuItem,
  Container
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useLocation } from 'react-router-dom';


// Logo component
const Logo = () => (
  <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', zIndex: 1000 }}>
      {/* <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L4 5v6c0 5.55 3.84 10.74 8 12 4.16-1.26 8-6.45 8-12V5l-8-3zm0 3.99l6 2.25V11c0 3.92-2.5 7.5-6 8.75-3.5-1.25-6-4.83-6-8.75V8.24l6-2.25z" fill="#1F2937" />
      </svg> */}
      <img
        src="/images/dunderdebunker.png"
        alt="DunderDebunk Logo"
        style={{ width: '36px', height: '36px', borderRadius: '50%' }} />

      <Typography
        variant="h6"
        component="div"
        sx={{
          fontWeight: 'bold',
          ml: 1,
          fontFamily: 'Arial, sans-serif',
          zIndex: 1000,
        }}
      >
        DunderDebunk
      </Typography>
    </Box>
  </Link>
);

// Navigation component can do gooey
const NavBar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // const navItems = [
  //   { name: 'Home', href: '/' },

  //   { name: 'Crediblity Checker', href: '/quick-check' },
  //   { name: 'Ctrl Alt Debunk', href: '/defence-game' },
  //   { name: 'Courses', href: '/education' },
  //   { name: 'Community Flagging', href: '/community-flagging' },
  //   { name: 'Quiz', href: '/quiz' },
  //   { name: 'Your Progress', href: '/personal-dashboard' },
  // ];
  const navItems = [
    { name: 'Home', href: '/' },
    { name: 'Crediblity Checker', href: '/quick-check', subtitle: 'Try our tool' },
    { name: 'Ctrl Alt Debunk', href: '/defence-game', subtitle: 'Play the game' },
    { name: 'Courses', href: '/education', subtitle: 'Learn media literacy' },
    { name: 'Community Flagging', href: '/community-flagging', subtitle: 'Help spot misinformation' },
    { name: 'Quiz', href: '/quiz', subtitle: 'Test your skills' },
    { name: 'Your Progress', href: '/personal-dashboard', subtitle: 'Track your journey' },
  ];


  const location = useLocation();


  return (
    <AppBar position="static" color="default" elevation={1}
      sx={{
        // backgroundColor: '#ffffff',
        // zIndex: 1000,
        // backdropFilter: "blur(10px)",
        // boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        backgroundColor: "rgba(255, 255, 255, 0.75)",
        boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.3)",
        color: "black",
        zIndex: 1000,
      }}>
      <Container maxWidth="xl">
        <Toolbar sx={{ justifyContent: 'space-between', zIndex: 1000 }}>
          <Logo />

          {isMobile ? (
            <>
              <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={handleMenuOpen}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                {navItems.map((item) => (
                  <MenuItem
                    key={item.name}
                    onClick={handleMenuClose}
                    component={Link}
                    to={item.href}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </Menu>
            </>
          ) : (
            // <Box sx={{ display: 'flex', alignItems: 'center', zIndex: 1000 }}>
            //   {navItems.map((item) => (
            //     <Button
            //       key={item.name}
            //       color="inherit"
            //       component={Link}
            //       to={item.href}
            //       sx={{
            //         textTransform: 'none',
            //         mx: 1,
            //         fontWeight: 'medium',
            //         fontSize: '0.95rem',
            //         zIndex: 1000,
            //         ...((
            //           item.name === 'Ctrl Alt Debunk' ||
            //           item.name === 'Crediblity Checker'
            //         ) && {
            //           color: '#001212',
            //           textShadow: '0 0 5px #001234, 0 0 10px #123499, 0 0 20px #192939',
            //           fontWeight: 'bold',
            //           animation: 'pulseGlow 2s infinite',
            //           '@keyframes pulseGlow': {
            //             '0%': {
            //               textShadow: '0 0 5px #ffaabb, 0 0 10px #f0ff6f, 0 0 20px #00ff6f',
            //             },
            //             '50%': {
            //               textShadow: '0 0 10px #ffaabb, 0 0 20px #f0ff6f, 0 0 40px #C03f4f',
            //             },
            //             '100%': {
            //               textShadow: '0 0 5px #ffaabb, 0 0 10px #f0ff6f, 0 0 20px #00Afff',
            //             },
            //           },
            //           ...(location.pathname === item.href && {
            //             backgroundColor: '#e0e0e0',
            //             borderRadius: '8px',
            //           }),
            //         }),
            //       }}
            //     >
            //       {item.name}
            //     </Button>
            //   ))}
            // </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', zIndex: 1000 }}>
              {navItems.map((item) => (
                <Button
                  key={item.name}
                  color="inherit"
                  component={Link}
                  to={item.href}
                  sx={{
                    textTransform: 'none',
                    mx: 1,
                    fontWeight: 'bold',
                    fontSize: '0.95rem',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    zIndex: 1000,
                    ...(location.pathname === item.href && {
                      backgroundColor: '#e0e0e0',
                      borderRadius: '8px',
                    }),
                  }}
                >
                  <Box component="span">{item.name}</Box>
                  {item.subtitle && (
                    <Typography variant="caption" sx={{ fontSize: '0.65rem', color: 'gray' }}>
                      {item.subtitle}
                    </Typography>
                  )}
                </Button>
              ))}
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default NavBar;
